import React, { useState } from 'react'
import EarningCalendar from './EarningCalendar'
import EarningsDayModal from './EarningsDayModal'
import useTickers from '../../../hooks/useTickers'
import Spinner from '../../Spinner'
import { MenuItem, Select, Typography, InputBase } from '@mui/material'
import Modal from '../../Modal'
import styles from '../../../pages/Dashboard.module.scss'

export default function Earnings() {
    const [earningsForModal, setEarningsForModal] = useState([])
    const [earningsModalVisibility, setEarningsModalVisibility] = useState(false)
    const [earningsDate, setEarningsDate] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [onlyWatchListEarnings, setOnlyWatchlistEarnings] = useState(true)
    const {getTickerName} = useTickers()
    
    const setOnlyWatchList = () => setOnlyWatchlistEarnings(!onlyWatchListEarnings)

    const options = [{value:'My Watchlist', name: 'My Watchlist'},{value: 'US Tickers', name: 'US Tickers'}]

    const openEarningsModal = () => setEarningsModalVisibility(true)
    const closeEarningsModal = () => {
        setEarningsForModal([])
        setEarningsModalVisibility(false)
    }


    return (<>
        <div className={styles['title']}>
            <Typography variant='h3'>
                Earnings Calendar
            </Typography>
            <Select
                variant='standard'
                value={onlyWatchListEarnings ? 'My Watchlist' : 'US Tickers'}
                onChange={setOnlyWatchList}
                input={<InputBase classes={{input: styles['input']}}/>}
                classes={{select: styles['select']}}
            >
                {options.map(value => <MenuItem value={value.value} key={value.name}>{value.name}</MenuItem>)}
            </Select>
        </div>
        <EarningCalendar 
            setDaysEarnings={setEarningsForModal} 
            setEarningsDate={setEarningsDate} 
            openEarningsModal={openEarningsModal}
            onlyWatchList={onlyWatchListEarnings}
        />
        <EarningsDayModal 
            open={earningsModalVisibility} 
            handleClose={closeEarningsModal} 
            dayEarnings={earningsForModal} 
            date={earningsDate}
            getTickerName={getTickerName}
            setIsLoading={setIsLoading}
        />
        <Modal open={!!isLoading}>
            <div className={styles['loading']}>
                <Spinner/>
            </div>
        </Modal> 
    </>)
}
